import React, { useState, useEffect } from 'react'
import {
    Collapse,
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import ScheduleIcon from '@material-ui/icons/Schedule'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import CloseIcon from '@material-ui/icons/Close'
import ArrowRightIcon from '@material-ui/icons/ArrowForward'
import TodayIcon from '@material-ui/icons/Today'
import EventIcon from '@material-ui/icons/Event'
import MoneyIcon from '@material-ui/icons/Money'
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import classNames from 'classnames'
import moment from "moment"
import { useIntl } from 'src/common/razzle-platform-translate'



const useStyles = makeStyles((theme) => ({
    actionsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 0,
        paddingBottom: 12,
    },
    bodyContainer: {
        display: 'flex',
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 0,
        paddingBottom: 12,
        flexDirection: 'column'
    },
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    timeSelect: {
        width: 41,
        // margin: '0 auto',
        background: '#eee',
        border: '1px solid #eee',
        padding: 2,
        outline: 0,
        display: 'block',
        height: 25,
        fontWeight: 400,
        lineHeight: 1.5,
        color: '#495057',
        borderRadius: '.25rem',
        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
    },
    hoursSelect: {
        marginRight: '0px',
        borderRight: '0px',
        background: "#fff"
    },
    minutesSelect: {
        marginLeft: '0px',
        borderLeft: '0px',
        background: "#fff"
    },
    colon: {
        border: '1px solid #eee',
        height: 19,
        borderRadius: 0,
        borderLeft: 0,
        borderRight: 0,
        background: "#fff",
        fontWeight: 'bold'
    },
    price: {
        marginRight: 15,
        padding: '0 10px',
        borderRadius: 12,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.default,
    },
    dataItem: {
        height: 60,
        paddingLeft: 10
    },
    dataItemEven: {
        background: fade(theme.palette.primary.main, 0.05),
    },
    dataItemOdd: {
        background: fade(theme.palette.primary.main, 0.1),
    },
    errorDescriptionArea: {
        backgroundColor: 'rgba(251, 135, 135, 0.64)',
        borderTop: '1px solid #00000008'
    },
    header: {
        height: 45,
        paddingLeft: 10,
    },
    dataItemSelected: {
        color: theme.palette.background.default,
        background: theme.palette.primary.main
    }
}))


const TimesSelectFields = (props) => {
    const classes = useStyles()
    const { minHour, maxHour, date, onChange, values } = props

    const renderHourOption = (type) => {
        const hoursOptions = []
        const selected = { selected: "selected" }
        for (var hour = minHour; hour <= maxHour; hour++) {
            if ((type === 'start_date' && hour < maxHour) || (type === 'end_date' && hour > minHour)) {
                hoursOptions.push(
                    <option
                        key={hour}
                        value={hour}
                        {...(type === 'start_date' && hour === minHour) ? selected : (type === 'end_date' && hour === maxHour) ? selected : null}
                    >
                        {hour}
                    </option>
                )
            }
        }
        return hoursOptions
    }


    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 7 }} >
                <select
                    name="startHours"
                    className={classNames(classes.timeSelect, classes.hoursSelect)}
                    onChange={(e) => onChange({ startDate: values.startDate.set('h', e.target.value) })}
                >
                    {renderHourOption('start_date')}
                </select>
                <span className={classNames(classes.colon, 'element')} >:</span>
                <select
                    name="startMinutes"
                    className={classNames(classes.timeSelect, classes.minutesSelect)}
                    onChange={(e) => onChange({ startDate: values.startDate.set('m', e.target.value) })}
                >
                    <option value="0" selected="selected" >00</option>
                </select>
            </div>
            <ArrowRightIcon style={{ fontSize: 18 }} />
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 45, marginLeft: 7 }} >
                <select
                    name="endHours"
                    className={classNames(classes.timeSelect, classes.hoursSelect)}
                    onChange={(e) => onChange({ endDate: values.endDate.set('h', e.target.value) })}
                    autofocus
                >
                    {renderHourOption('end_date')}
                </select>
                <span className={classNames(classes.colon, 'element')} >:</span>
                <select
                    name="endMinutes"
                    className={classNames(classes.timeSelect, classes.minutesSelect)}
                    onChange={(e) => onChange({ endDate: values.endDate.set('m', e.target.value) })}
                >
                    <option value="0" selected="selected">00</option>
                </select>
            </div>

        </>
    )
}



function TimePicker(props) {
    const { time, index, error, onChange, isSelected } = props
    const { formatMessage } = useIntl()
    const minHour = time.startDate.get('hour')
    const maxHour = time.endDate.get('hour')
    const classes = useStyles()
    const [values, setValues] = useState({
        startDate: moment(time.startDate.format('YYYY-MM-DD HH'), 'YYYY-MM-DD HH'),
        endDate: moment(time.endDate.format('YYYY-MM-DD HH'), 'YYYY-MM-DD HH')
    })


    useEffect(() => {
        const validate = () => {
            if (!values.endDate.isAfter(values.startDate)) {
                return formatMessage({ id: 'La date de début doit être inférieure à la date de fin', defaultMessage: 'La date de début doit être inférieure à la date de fin'})
            }
            const deltaTime = (values.endDate.clone().diff(values.startDate.clone(), 'h'))

            if (deltaTime < time.unitNumbers * time.minPeriodicity) {
                return `${formatMessage({ id: "La valeur minimale que doit selectionner c'est", defaultMessage: "La valeur minimale que doit selectionner c'est"})} ${time.unitNumbers * time.minPeriodicity} ${ formatMessage({ id: 'heurs', defaultMessage: 'heurs' })}`
            }

            if (deltaTime % time.unitNumbers !== 0) {
                return `${formatMessage({ id: 'La valeur doit être multiple de', defaultMessage: 'La valeur doit être multiple de'})} ${time.unitNumbers}`
            }

            return null
        }
        if (isSelected) {
            onChange({startDate: values.startDate, numberOfUnity: values.endDate.diff(values.startDate, 'hours') / time.unitNumbers})
        }
        props.onError(validate())
    }, [values])


    const unitLabel = time.unitNumbers === 1 ? formatMessage({ id: 'Heure', defaultMessage: 'Heure'}) : `${time.unitNumbers}${formatMessage({ id: 'Heures', defaultMessage: 'Heures'})}`
    return (
        <>
            <ListItem role={undefined} dense className={classNames(classes.header, isSelected ? classes.dataItemSelected : index % 2 === 0 ? classes.dataItemOdd : classes.dataItemEven)} style={{
                ...error && { backgroundColor: 'rgba(251, 135, 135, 0.64)', color: 'inherit' }
            }} >
                <ListItemIcon style={{ minWidth: 33, color: isSelected ? '#fff' : 'inherit', ...error && { color: 'inherit' } }}>
                    <ScheduleIcon />
                </ListItemIcon>
                <ListItemText id={time} primary={<Typography style={{ fontWeight: isSelected ? 'bold' : 'inherit' }} variant="body2" >{time.startDate.format('HH:mm')} to {time.endDate.format('HH:mm')}</Typography>} />

                {!isSelected && <Typography variant="body2" className={classes.price} >{`${time.price}${formatMessage({ id: '€', defaultMessage: '€' })} / ${unitLabel}`}</Typography>}
                {isSelected &&
                    <TimesSelectFields
                        minHour={minHour}
                        maxHour={maxHour}
                        onChange={(value) => setValues({ ...values, ...value })}
                        values={values}
                    />
                }
                <ListItemSecondaryAction>
                    {!isSelected &&
                        <IconButton edge="end" aria-label="comments" onClick={() => {
                            props.onSelectedItem(time)
                            props.onChange({startDate: time.startDate, numberOfUnity: time.endDate.diff(values.startDate, 'hours') / time.unitNumbers})
                        }} >
                            <AddCircleIcon />
                        </IconButton>
                    }
                    {isSelected &&
                        <>
                            <IconButton edge="end" aria-label="comments" onClick={() => {
                                setValues({
                                    startDate: moment(time.startDate.format('YYYY-MM-DD HH'), 'YYYY-MM-DD HH'),
                                    endDate: moment(time.endDate.format('YYYY-MM-DD HH'), 'YYYY-MM-DD HH')
                                })
                                props.onSelectedItem(null)
                            }} >
                                <CloseIcon style={{ color: '#e53935' }} />
                            </IconButton>
                        </>
                    }

                </ListItemSecondaryAction>
            </ListItem>
            <Collapse in={!!error} >
                <ListItem className={classes.errorDescriptionArea}>
                    {error}
                </ListItem>
            </Collapse>


            <Collapse in={isSelected && !error} >
                <ListItem role={undefined} dense className={classNames(classes.dataItem, classes.dataItemOdd)}>
                    <ListItemIcon >
                        <TodayIcon />
                    </ListItemIcon>
                    <ListItemText id={'unitPrice'} primary={<Typography>{formatMessage({ id: 'Date de début', defaultMessage: 'Date de début' })}</Typography>} />
                    <ListItemSecondaryAction>
                        <Typography>{values.startDate.format('DD-MM-YYYY HH:mm')}</Typography>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense className={classNames(classes.dataItem, classes.dataItemEven)}>
                    <ListItemIcon >
                        <EventIcon />
                    </ListItemIcon>
                    <ListItemText id={'unitPrice'} primary={<Typography>{formatMessage({ id: 'Date de fin', defaultMessage: 'Date de fin' })}</Typography>} />
                    <ListItemSecondaryAction>
                        <Typography>{values.endDate.format('DD-MM-YYYY HH:mm')}</Typography>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense className={classNames(classes.dataItem, classes.dataItemOdd)}>
                    <ListItemIcon >
                        <LocalAtmIcon />
                    </ListItemIcon>
                    <ListItemText id={'unitPrice'} primary={<Typography>{ formatMessage({ id: 'Prix unitaire', defaultMessage: 'Prix unitaire' }) }</Typography>} />
                    <ListItemSecondaryAction>
                        <Typography>{time.price} {`${ formatMessage({ id: '€', defaultMessage: '€' }) } / ${unitLabel}`}</Typography>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense className={classNames(classes.dataItem, classes.dataItemEven)}>
                    <ListItemIcon >
                        <MoneyIcon />
                    </ListItemIcon>
                    <ListItemText id={'totalPrice'} primary={<Typography>{formatMessage({ id: 'Prix total', defaultMessage: 'Prix total' })}</Typography>} />
                    <ListItemSecondaryAction>
                        <Typography  >{time.price * values.endDate.diff(values.startDate, 'hours') / time.unitNumbers} { formatMessage({ id: '€', defaultMessage: '€' }) }</Typography>
                    </ListItemSecondaryAction>
                </ListItem>

            </Collapse>
        </>
    )
}


export default TimePicker
